import * as React from "react"
import Layout from "../components/layout";
import Header from "../components/header";
import {Intro} from "../components/player";

const IndexPage = (props) => {

    return (
        <Layout pageTitle="Landtag im Flug | Bayerischer Landtag">
            <Header className="intro"/>
            <Intro/>
        </Layout>
    )
}

export default IndexPage
